import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type TagControlConfigFragment = { controls: Array<{ controllingEntity: { type: Types.TagControlSourcePropertyTypeEnum, value: string }, rules: Array<{ source: { operator: Types.TagControlOperatorEnum, values: Array<string> }, target: { operator: Types.TagControlOperatorEnum, values: Array<string> } }> }> };


export type TagControlConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const TagControlConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment TagControlConfig on TagControlConfigType {
  controls {
    controllingEntity {
      type
      value
    }
    rules {
      source {
        operator
        values
      }
      target {
        operator
        values
      }
    }
  }
}
    `;